import type { AssetTypeTemplateHeaderButtonsProps } from "./asset-type-template-header-buttons.type";

import InfoButton from "@/components/Header/Button/InfoButton";
import HeaderButtonList from "@/components/Header/HeaderButtonList/HeaderButtonList";
import { BUTTON_KEYS, BUTTON_TYPE } from "@/constants/Button";
import { AssetTypeTemplateDeleteButton } from "@/modules/asset-type-template/asset-type-template-delete-button";
import { AssetTypeTemplateDuplicateButton } from "@/modules/asset-type-template/asset-type-template-duplicate";
import { AssetTypeTemplateEdit } from "@/modules/asset-type-template/asset-type-template-edit";
import { AssetTypeTemplateInfo } from "@/modules/asset-type-template/asset-type-template-info";
import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";
import { EditButton } from "@/ui/edit-button";

export const AssetTypeTemplateHeaderButtons = ({
  template,
}: AssetTypeTemplateHeaderButtonsProps) => {
  const { openSidePanel } = useSidePanel();
  const { canCreate, canUpdate, canDelete } = useAuthorization();

  if (!template) {
    return;
  }

  const onEditClick = () => {
    openSidePanel({
      title: template.name,
      component: <AssetTypeTemplateEdit template={template} />,
    });
  };

  const onInfoSelect = () => {
    openSidePanel({
      title: template.name,
      component: <AssetTypeTemplateInfo entityTemplate={template} />,
    });
  };

  const primaryActions = [
    <InfoButton key="info" onInfoSelect={onInfoSelect} />,
  ];
  const secondaryActions = [];

  if (canUpdate(template)) {
    secondaryActions.push({
      key: BUTTON_KEYS.EDIT,
      label: (
        <EditButton key={BUTTON_KEYS.EDIT} type="text" onClick={onEditClick} />
      ),
    });
  }

  if (canCreate("technicalform")) {
    secondaryActions.push({
      key: BUTTON_KEYS.DUPLICATE,
      label: (
        <AssetTypeTemplateDuplicateButton
          key={BUTTON_KEYS.DUPLICATE}
          template={template}
          type="text"
          showIcon
        />
      ),
    });
  }

  if (canDelete(template)) {
    secondaryActions.push({
      key: BUTTON_KEYS.DELETE,
      label: (
        <AssetTypeTemplateDeleteButton
          entityTemplate={template}
          type={BUTTON_TYPE.TEXT}
          hideDanger
        />
      ),
    });
  }

  return (
    <HeaderButtonList
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
    />
  );
};
